import { render } from "./BookViewIntro.vue?vue&type=template&id=30e5974a&scoped=true"
import script from "./BookViewIntro.vue?vue&type=script&lang=js"
export * from "./BookViewIntro.vue?vue&type=script&lang=js"

import "./BookViewIntro.vue?vue&type=style&index=0&id=30e5974a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30e5974a"

export default script